export default __webpack_public_path__ + "static/media/right.c266a96c.svg";